<template>
  <div class="monitor">
      <div class="monitor-header">
        <div class="plateNumber">{{ carLocation.plateNumber }}</div>
        <div class="reflash" @click="refashMap">刷新</div>
      </div>
      <div class="monitor-map" id="monitor-map"></div>
      <div class="monitor-tolls">
        <div class="traffic" @click="toggleTraffic"><img :src="trafficUrl()" alt=""></div>
        <div class="playback" @click="playbackList"><img src="../../assets/image/guiji.png" alt=""></div>
        <div class="location" @click="getCenter"><img src="../../assets/image/location.png" alt=""></div>
      </div>
      <div v-show="false">
        <div class="infobox" ref="customInfobox">
          <div class="carMsg">
            <div class="carImg"><img :src="carTypeImg(carLocation.carType)" alt /></div>
            <div class="carMsg-detail">
              <div class="label">
                <span>{{ carLocation.plateNumber }}</span>
                <span class="line"></span>
                <span>{{ carLocation.driveName }}</span>
              </div>
              <div class="alarm">{{ alarmList[carLocation.alarmType] }}</div>
            </div>
            <div class="carStatus">{{ carLocation.status | statusFil }}</div>
          </div>
          <div class="car-tabs">
            <div class="tab">
              <div class="label">当前速度</div>
              <div class="value">{{ carLocation.speed }}<span class="count">km/h</span></div>
            </div>
            <div class="tab">
              <div class="label">今日里程</div>
              <div class="value">{{ carLocation.mileage }}<span class="count">km</span></div>
            </div>
            <div class="tab">
              <div class="label">载重</div>
              <div class="value">{{ carLocation.load ||'--' }}<span class="count" v-show="carLocation.load">km</span></div>
            </div>
            <div class="tab">
              <div class="label">ACC状态</div>
              <div class="value" style="font-size:16px;font-weight:700">{{ carLocation.acc == 1 ? "点火" : "熄火" }}</div>
            </div>
          </div>
          <div class="currentMsg">
            <div class="label">设备信息：</div>
            <div class="value" style="font-weight:700">{{ carLocation.type | deviceTypeFil }}-{{ carLocation.hardwareProtocol | deviceProtoFil }}</div>
          </div>
          <div class="currentMsg">
            <div class="label">定位信号：</div>
            <div class="value"><span style="color: #39D995;">{{ carLocation.gpsSignal }}</span></div>
          </div>
          <div class="currentMsg">
            <div class="label">数据更新时间：</div>
            <div class="value update">{{ carLocation.lastServerTime }}</div>
          </div>
          <div class="currentMsg">
            <div class="label">定位时间：</div>
            <div class="value">{{ carLocation.lastDataTime }}</div>
          </div>
          <div class="currentMsg">
            <div class="label">定位地址：</div>
            <div class="value">{{ carLocation.address }}</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
const imageArr = ["", "green_car_", "red_car_", "yellow_car_", "black_car_", "location_gray_car_", "purple_car_", "blue_car_", "wireless_gray_car_", "car_cyan_"];
export default {
  data() {
      return {
        key:'',
        defaultType: 0,
        aMap: null,
        aMapInfo: null,
        aMapInfoOpen: false,
        trafficLayer: null,
        trafficFlag: false,
        markList: {},
        carLocation:{},
        refashTimer:null,
        alarmList: {
          0: "正常",
          1: "断电报警",
          2: "超速报警",
          3: "低电压报警",
          4: "离线超时报警",
          5: "出行政区域报警",
          6: "出围栏报警",
          7: "进区域报警",
          8: "出区域报警",
          9: "线路偏移报警",
          10: "非法拆除报警",
          11: "怠速报警",
          12: "低速报警",
          13: "疲劳驾驶报警",
          14: "高温报警",
          15: "低温报警",
          16: "高湿度报警",
          17: "低湿度报警",
          18: "胎压过低报警",
          19: "胎压过高报警",
          20: "胎温过高报警",
          21: "胎压传感器异常报警",
          22: "胎压不平衡报警",
          23: "慢漏气报警",
          24: "胎压传感器电量过低报警",
          25: "超载报警",
        },
      }
  },
  mounted() {
    this.key = this.$route.query.key
    this.aMap = new AMap.Map('monitor-map', {
      zoom: 11,//级别
      center: [120.19574222222222, 30.346933333333332],//中心点坐标
      mapStyle:'amap://styles/fresh'
    });
    this.trafficLayer = new AMap.TileLayer.Traffic({
      zIndex: 10
    });
    this.trafficLayer.setMap(this.aMap);
    this.trafficLayer.hide()
    this.getCarLocation()
    this.refashTimer && clearInterval(this.refashTimer)
    this.refashTimer = setInterval(() => {
      this.refashMap()
    }, 10000);
    this.$once('hook:beforeDestroy', () => {            
      clearInterval(this.refashTimer);                                    
    })
},
  filters: {
    statusFil(val) {
      let statusObj = {
        1: "行驶",
        2: "停车",
        3: "报警",
        4: "离线",
        5: "不定位",
      };
      return statusObj[val];
    },
    deviceTypeFil(val) {
      let typeObj = {
        1: "GPS有线设备",
        2: "GPS无线设备",
        3: "OBD设备",
      };
      return typeObj[val];
    },
    deviceProtoFil(val) {
      let typeObj = {
        1: "WYMinis",
        3: "WYOBD",
        4: "WYOBD带车况",
        5: "行车记录仪",
        6: "云镜",
        7: "WY05",
        8: "WYP9",
        9: "WYA4C",
      };
      return typeObj[val];
    },
  },  
  methods: {
      async getCarLocation() {
        const data = await this.$api.getCarLocation(this.key)
        if(data.success) {
          this.carLocation = data.datas.content
        }
        // this.$ls.set('h5-plateNumber',this.carLocation.plateNumber)
        this.addDeviceMarks()
        this.infoBoxInit()
      },
      async refashMap() {
        // this.aMap.clearMap();
        // this.getCarLocation()
        const data = await this.$api.getCarLocation(this.key)
        if(data.success) {
          this.carLocation = data.datas.content
        } 
        this.addDeviceMarks()
      },
      infoBoxInit() {
        if (this.aMapInfo) return false
        this.aMapInfo = new AMap.InfoWindow({
          isCustom: true,  //使用自定义窗体
          offset: new AMap.Pixel(8, -45)
        });
      },
      closeInfoBox() {
        this.aMapInfo.close()
        this.aMapInfoOpen = false
      },
      addDeviceMarks() {
          let imagePath = `${imageArr[this.carLocation.status]}${this.getDirectInfo(this.carLocation.direct).image}`
          let icons = require(`@/assets/image/monitornew/${imagePath}`)
          let markIcon = new AMap.Icon({
            size: new AMap.Size(35, 35),
            image: icons,
            imageSize: new AMap.Size(35, 35),
          });
          // AMap.convertFrom([this.carLocation.lng, this.carLocation.lat], 'gps', (status, result) => {
          //   if (result.info === 'ok') {
              if(!Object.keys(this.markList).length == 0) {
                this.markList.setIcon(markIcon)
                this.markList.setPosition([this.carLocation.lng, this.carLocation.lat])
                if(this.aMapInfoOpen){
                  let infoboxHTML = this.$refs.customInfobox
                  this.aMapInfo.setContent(infoboxHTML)
                  this.aMapInfo.setPosition([this.carLocation.lng, this.carLocation.lat])
                }
              }else {
                let marker = new AMap.Marker({
                  position: [this.carLocation.lng, this.carLocation.lat],
                  icon: markIcon,
                  map: this.aMap,
                });
                AMap.event.addListener(marker, 'click', (e) => {
                  if(this.aMapInfoOpen) {
                    this.closeInfoBox()
                  }else {
                    this.setInfoWinow(marker)
                  } 
                });
                this.markList = marker
              }
              this.aMap.setCenter([this.carLocation.lng, this.carLocation.lat]);
          //   }
          // })
      },
      setInfoWinow(marker){
        let infoboxHTML = this.$refs.customInfobox
        this.aMapInfo.setContent(infoboxHTML)
        this.aMapInfo.open(this.aMap, marker.getPosition());
        // this.aMap.setCenter(marker.getPosition());
        this.aMapInfoOpen = true
      },
      getCenter() {
        this.aMap.setCenter(this.markList.getPosition());
      },
      toggleTraffic() {
        this.trafficFlag = !this.trafficFlag
        if(this.trafficFlag) {
          this.trafficLayer.show()
        }else {
          this.trafficLayer.hide()
        }
      },
      trafficUrl() {
        return require(`@/assets/image/${this.trafficFlag?'traffic_checked':'traffic'}.png`)
      },
      playbackList() {
        this.$router.push({
          path:'/realtime/playbackList',
          query: {
            plateNumber: this.carLocation.plateNumber,
            key: this.key
          }
        })
      },
      getDirectInfo(direct) {
        var rtDirect = {};
        if (direct > 27 && direct <= 72) {
          rtDirect.image = "45.png";
          rtDirect.direction = "东北";
        } else if (direct > 72 && direct <= 117) {
          rtDirect.image = "90.png";
          rtDirect.direction = "东";
        } else if (direct > 117 && direct <= 162) {
          rtDirect.image = "135.png";
          rtDirect.direction = "东南";
        } else if (direct > 162 && direct <= 207) {
          rtDirect.image = "180.png";
          rtDirect.direction = "南";
        } else if (direct > 207 && direct <= 252) {
          rtDirect.image = "225.png";
          rtDirect.direction = "西南";
        } else if (direct > 252 && direct <= 297) {
          rtDirect.image = "270.png";
          rtDirect.direction = "西";
        } else if (direct > 297 && direct <= 342) {
          rtDirect.image = "315.png";
          rtDirect.direction = "西北";
        } else {
          rtDirect.image = "0.png";
          rtDirect.direction = "北";
        }
        return rtDirect;
      },
      carTypeImg(val) {
        if (!val) return;
        return require(`@/assets/image/carType/${val}.png`);
      },
  }
}
</script>

<style lang="scss">
    .amap-copyright {
        display: none !important;
        visibility: hidden !important;
    }
    .amap-logo {
        display: none !important;
    }
    .tagStyle {
        font-weight: 700 !important;
    }
    .amap-maptype-list {
      display: none!important;
    }
    .amap-maptype-wrap {
      display: none!important;
    }
    .monitor {
      position: relative;
      height: 100%;
      &-header {
        height: 50px;
        width: 100vw;
        position: fixed;
        z-index: 999;
        top: 0;
        background-image: linear-gradient(109deg, #EBF3F9 41%, #F3F7FB 99%);
        box-sizing: border-box;
        padding: 0 15px;
        text-align: center;
        .reflash {
          position: absolute;
          right: 15px;
          top: 0;
          height: 50px;
          line-height: 50px;
          font-family: PingFangSC;
          font-weight: 700;
          font-size: 16px;
          color: #000000;
        }
        .plateNumber {
          height: 50px;
          line-height: 50px;
          font-family: PingFangSC;
          font-weight: 700;
          font-size: 19px;
          color: #000000;
          display: inline-block;
        }
      } 
      &-map {
          position: absolute;
          top: 50px;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100vw;
          height: calc(100vh - 50px);/* px-to-viewport-ignore */
      }
      &-tolls {
        position: fixed;
        width: 40px;
        height: 140px;
        right: 15px;
        top: 65px;/* px-to-viewport-ignore */
        z-index: 999;
        &>div {
          width: 40px;
          height: 40px;
          margin-bottom: 10px
        }
        &>div:last-child {
          margin-bottom: 0px
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .markLabel {
        background: #fff;
        padding: 5px;
        border: #00b38a 1px solid;
        border-radius: 3px;

        span {
          color: #00b38a;
        }
      }
      .infobox {
        position: relative;
        width: 384px;
        height: 272.5px;
        background-color: #fff;
        border-radius: 15px;
        padding: 18px 15px 0 19px;
        box-sizing: border-box;
        &::after {
          border: solid transparent;
          content: " ";
          height: 0;
          bottom: -7.5px; //根据三角形的位置，可以随意更改。
          left: 50%;
          transform: translateX(-50%);
          position: absolute;
          width: 0;
          border-width: 7.5px 5px 0px 5px;
          border-top-color: #fff;
        }
        .carMsg {
          height: 43px;
          margin-bottom: 10px;
          .carImg {
            display: inline-block;
            height: 25px;
            vertical-align: middle;
            margin: 8.5 0 0 4px;
            &>img {
              height: 100%;
            }
          }
          &-detail {
            width: 180px;
            height: 43px;
            display: inline-block;
            vertical-align: middle;
            margin-left: 8.5px;
            .label {
              height: 24px;
              line-height: 24px;
              font-family: PingFangSC;
              font-weight: 700;
              font-size: 17px;
              color: #323840;
              .line {
                display: inline-block;
                width: 1px;
                height: 12px;
                margin: 6px 7.5px 0 5px;
                background: #DADEDD;
              }
            }
            .alarm {
              height: 19px;
              line-height: 19px;
              font-family: PingFangSC-Regular;
              font-size: 13px;
              color: #414852;
            }
          }
          .carStatus {
            display: inline-block;
            width: 49px;
            height: 24px;
            line-height: 24px;
            border-radius: 12px;
            background-image: linear-gradient(90deg, #39D995 0%, #00B3A0 95%);
            font-family: PingFangSC;
            font-weight: 700;
            font-size: 13px;
            color: #FFFFFF;
            text-align: center;
            float: right;
            margin-top: 10px;
          }
        }
        .car-tabs {
          width: 354px;
          height: 54px;
          background: #F3F8FB;
          border-radius: 26px;
          display: flex;
          justify-content: space-around;
          box-sizing: border-box;
          padding-left: 10px;
          margin-bottom: 10px;
          .tab {
            flex: 1;
            text-align: center;
            .label {
              height: 18px;
              line-height: 18px;
              font-family: PingFangSC-Regular;
              font-size: 12.5px;
              color: #4A4E53;
              margin-top: 6px;
            }
            .value {
              height: 26.5px;
              line-height: 26.5px;
              font-family: DINAlternate;
              font-size: 23px;
              color: #414852;
              .count {
                font-family: PingFangSC-Regular;
                font-size: 11px;
                color: #4A4E53;
              }
            }
          }
        }
        .currentMsg {
          height: 20px;
          line-height: 20px;
          margin-bottom: 3.5px;
          font-size: 14px;
          &>div {
            display: inline-block;
            vertical-align: middle;
          }
          .label {
            color: #414852;
          }
          .value {
            width: calc(100% - 80px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #1D1E22;
            &.update {
              width: calc(100% - 130px);
            }
            .line {
              display: inline-block;
              width: 1px;
              height: 12px;
              margin: 4px 7px 0 6px;
              background: #DADEDD;
            }
          }
        }
      }
    }
</style>
